import React from 'react';

export default function Insights({ active }: { active?: boolean }) {
  return (
    <>
      {active ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M15.7671 4.61693C17.1837 5.24193 17.1837 6.27526 15.7671 6.90026L10.8504 9.08359C10.2921 9.33359 9.37539 9.33359 8.81706 9.08359L3.90039 6.90026C2.48372 6.27526 2.48372 5.24193 3.90039 4.61693L8.81706 2.43359C9.37539 2.18359 10.2921 2.18359 10.8504 2.43359L12.4504 3.14193"
            stroke="#F7F7F7"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2.5 9.16699C2.5 9.86699 3.025 10.6753 3.66667 10.9587L9.325 13.4753C9.75833 13.667 10.25 13.667 10.675 13.4753L16.3333 10.9587C16.975 10.6753 17.5 9.86699 17.5 9.16699"
            stroke="#F7F7F7"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2.5 13.333C2.5 14.108 2.95833 14.808 3.66667 15.1247L9.325 17.6413C9.75833 17.833 10.25 17.833 10.675 17.6413L16.3333 15.1247C17.0417 14.808 17.5 14.108 17.5 13.333"
            stroke="#F7F7F7"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10.8406 2.43335L15.7573 4.61668C17.174 5.24168 17.174 6.27502 15.7573 6.90002L10.8406 9.08335C10.2823 9.33335 9.36562 9.33335 8.80729 9.08335L3.89063 6.90002C2.47396 6.27502 2.47396 5.24168 3.89063 4.61668L8.80729 2.43335C9.36562 2.18335 10.2823 2.18335 10.8406 2.43335Z"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2.5 9.16675C2.5 9.86675 3.025 10.6751 3.66667 10.9584L9.325 13.4751C9.75833 13.6667 10.25 13.6667 10.675 13.4751L16.3333 10.9584C16.975 10.6751 17.5 9.86675 17.5 9.16675"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2.5 13.3333C2.5 14.1083 2.95833 14.8083 3.66667 15.1249L9.325 17.6416C9.75833 17.8333 10.25 17.8333 10.675 17.6416L16.3333 15.1249C17.0417 14.8083 17.5 14.1083 17.5 13.3333"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )}
    </>
  );
}
